import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Divider,
} from "antd";
import React from "react";
import {
  eduOptions,
  healthOptions,
  professionOptions,
} from "pages/Family/components/constants/constants";
import {
  MinusCircleOutlined,
  PlusOutlined,
  UserOutlined,
  DollarOutlined,
  HeartOutlined,
} from "@ant-design/icons";

const ChildrenForm = () => {
  return (
    <Form.List name="children">
      {(fields, { add, remove }) => (
        <div className="space-y-6">
          {fields.map(({ key, name, ...restField }, index) => (
            <Card
              key={key}
              title={
                <span className="text-lg font-semibold flex items-center gap-2 text-blue-600">
                  <UserOutlined /> بيانات الابن {index + 1}
                </span>
              }
              bordered={false}
              className="shadow-sm bg-gray-50"
              extra={
                <Button
                  type="text"
                  danger
                  onClick={() => remove(name)}
                  icon={<MinusCircleOutlined />}
                >
                  حذف الابن
                </Button>
              }
            >
              {/* 👤 Personal Info */}
              <Divider orientation="right" plain>
                المعلومات الشخصية
              </Divider>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={8} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "firstName"]}
                    label="الاسم"
                  >
                    <Input placeholder="أدخل الاسم" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "middleName"]}
                    label="اسم الأب"
                  >
                    <Input placeholder="أدخل اسم الأب" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "lastName"]}
                    label="الكنية"
                  >
                    <Input placeholder="أدخل الكنية" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "birthdate"]}
                    label="تاريخ الميلاد"
                  >
                    <DatePicker format="DD-MM-YYYY" className="w-full" />
                  </Form.Item>
                </Col>
              </Row>

              {/* ❤️ Health Info */}
              <Divider orientation="right" plain>
                الحالة الصحية
              </Divider>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "healthStatus"]}
                    label="الحالة الصحية"
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="اختر الحالة الصحية"
                      options={healthOptions}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* 🎓 Education & Work Info */}
              <Divider orientation="right" plain>
                التعليم والعمل
              </Divider>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "education"]}
                    label="التعليم"
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="اختر المستوى التعليمي"
                      options={eduOptions}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "professional"]}
                    label="المهنة"
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="اختر المهنة"
                      options={professionOptions}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    name={[name, "jobTitle"]}
                    label="الوظيفة"
                    initialValue={""}
                  >
                    <Input placeholder="أدخل الوظيفة" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    name={[name, "workplace"]}
                    label="مكان العمل"
                    initialValue={""}
                  >
                    <Input placeholder="أدخل مكان العمل" />
                  </Form.Item>
                </Col>
              </Row>

              {/* 💰 Financial Info */}
              <Divider orientation="right" plain>
                المعلومات المالية
              </Divider>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item name={[name, "salary"]} label="الراتب">
                    <Input type="number" placeholder="أدخل الراتب" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item name={[name, "income"]} label="الدخل السنوي">
                    <Input type="number" placeholder="أدخل الدخل السنوي" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                  <Form.Item
                    name={[name, "expectedExpenses"]}
                    label="النفقات المتوقعة"
                  >
                    <Input
                      type="number"
                      inputMode="numeric"
                      placeholder="أدخل المبلغ المتوقع للنفقات الشهرية"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Button
                type="dashed"
                danger
                onClick={() => remove(name)}
                icon={<MinusCircleOutlined />}
              >
                حذف الابن
              </Button>
            </Card>
          ))}

          {/* ➕ Add Child Button */}
          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              إضافة ابن
            </Button>
          </Form.Item>
        </div>
      )}
    </Form.List>
  );
};

export default ChildrenForm;
